<template>
  <div class="policyDocumentsDetail">
    <div class="alert-box">
      <div class="alert">
        <a-alert
          v-if="visible"
          :message="visibleText"
          type="success"
          show-icon
          closable
          :after-close="
            () => {
              visible = false;
            }
          "
        />
      </div>
    </div>
    <div class="cont_top">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="政策文件" key="policyDocumentsDetail"></a-tab-pane>
      </a-tabs>
      <p class="title">
        <span
          class="info_title"
          :class="{ info_max: info.Title && info.Title.length >= 45 }"
          >{{ info.Title }}</span
        >
        <span
          class="info_ct"
          @click="openNotification()"
          v-if="page.indexOf('corp') > -1"
        >
          <span v-show="!isCollected" @click="addCollection()">
            <svg-icon class="mgr" icon-class="collection"></svg-icon>收藏
          </span>
          <span v-show="isCollected" @click="cancelCollection()">
            <svg-icon class="mgr" icon-class="collected"></svg-icon> 已收藏
          </span>
        </span>
      </p>
      <p class="p1">发文部门：{{ info.Dept }}</p>
      <!-- 取消？<p class="p2">申报时间：2021-05-10-2021-06-16</p> -->
      <p>
        发布日期： {{ info.PublishTime }}
        <!-- <a-button
          type="primary"
          style="margin-left: 20px"
          @click="policyVisible = true"
        >
          推送企业
        </a-button> -->
        <a-button type="primary" style="margin-left: 10px" @click="redirect()"
          >微信分享</a-button
        >
      </p>
    </div>
    <div class="mainContent">
      <div class="mainBox mainBox1">
        <div class="title">
          <span class="desc1"></span>
          <span class="desc2">政策详情</span>
        </div>
        <div class="declareCondition">
          <span v-html="info.Content"></span>
        </div>
      </div>
      <div class="mainBox">
        <div class="title">
          <span class="desc1"></span>
          <span class="desc2">相关附件</span>
        </div>
        <div v-for="(el, index) in info.attachments" :key="index">
          <a-button type="link" @click.stop="download(el.path)" v-if="el.name">
            {{ el.name }}
          </a-button>
        </div>
      </div>
    </div>
    <qr-code
      v-if="codeVisible"
      businessType="news"
      :visiable.sync="codeVisible"
      :maskClosable="false"
      :url="url"
      :targetDesc="info.Title"
      :targetId="businessId"
    ></qr-code>
    <!-- <policy-push
      v-if="policyVisible"
      ref="policyPush"
      :policyVisible.sync="policyVisible"
      :policyMessage="policyMessage"
    ></policy-push> -->
  </div>
</template>

<script>
import qrCode from "@/components/qrCode";
// import policyPush from "@/components/policyPush";
import {
  outerDetail,
  checkColle,
  addColle,
  cancelColle,
} from "@/api/policyDocuments";
export default {
  components: {
    qrCode,
    // policyPush,
  },
  // props: {
  //   businessId: {
  //     type: String,
  //     required: true,
  //   },
  // },
  name: "policyDocumentsDetail",
  data() {
    return {
      visibleText: "",
      url: "",
      visible: false,
      codeVisible: false,
      policyVisible: false,
      isCollected: false,
      activeName: "policyDocumentsDetail",
      info: {
        attachments: [],
      },
      page: "",
      businessId: ''
    };
  },
  created() {
    this.page = sessionStorage.getItem("page") || "";
    let searchObj = {};
    let search = window.location.search;
    search = search.replace("?", "");
    search = search.split("&");
    search.forEach((n) => {
      let arr = n.split("=");
      searchObj[arr[0]] = arr[1];
    });
    this.businessId = searchObj.targetId;
    this.businessId && this.pageInit();
  },
  methods: {
    async pageInit() {
      const res = await outerDetail({ id: this.businessId });
      this.info = res.data.info;
      const collectionData = await checkColle({
        businessType: "news",
        orgId: "",
        targetId: this.businessId.toString(),
        tenantId: "",
        userId: "",
        sourceMark: 1,
        targetDesc: this.info.Title,
      });
      this.isCollected = collectionData.data === 0 ? false : true;
    },
    async addCollection() {
      await addColle({
        businessType: "news",
        orgId: "",
        targetId: this.businessId.toString(),
        tenantId: "",
        userId: "",
        sourceMark: 1,
        targetDesc: this.info.Title,
      });
    },
    async cancelCollection() {
      await cancelColle({
        businessType: "news",
        orgId: "",
        targetId: this.businessId.toString(),
        tenantId: "",
        userId: "",
        sourceMark: 1,
        targetDesc: this.info.Title,
      });
    },
    //打开下载文件
    download(path) {
      window.open(path);
    },
    //跳转H5分享
    redirect() {
      this.url =
        "https://policytest.gongsibao.com/fileSharing?targetId=" +
        this.businessId.toString();
      this.codeVisible = true;
    },
    //收藏
    openNotification() {
      this.isCollected = !this.isCollected;
      this.visibleText = "收藏成功,稍后可在【收藏记录】中查看。";
      if (!this.isCollected) {
        this.visibleText = "取消收藏 ";
      }
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, 1500);
    },
  },
  computed: {
    policyMessage() {
      return [
        {
          id: this.businessId,
          jobName: this.info.Title ? this.info.Title : "",
          info: this.info.Content ? this.info.Content : "",
        },
      ];
    },
  },
  // watch: {
  //   $route: {
  //     immediate: true,
  //     handler(val) {
  //       if (val.query) {
  //         this.queryParam = val.query;
  //         this.pageInit();
  //       }
  //     },
  //     deep: true,
  //   },
  // },
};
</script>

<style lang="less" scoped>
@bgColor: #fff;

.policyDocumentsDetail {
  position: relative;
  overflow: hidden;
  padding: 10px;
  font-family: PingFangSC-Medium, PingFang SC !important;

  .cont_top {
    background: @bgColor;
    padding: 20px;
    margin-bottom: 10px;

    ::v-deep .ant-tabs-tab-active {
      font-weight: 500;
      color: #333;
      font-size: 16px;
      padding: 12px 0;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: #999;
      margin: 0;
    }

    .p1 {
      margin-bottom: 16px;
    }

    .p2 {
      margin-bottom: 7px;
    }

    .title {
      font-size: 20px;
      font-weight: 500;
      color: #333;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        &.info_title {
          flex: 1;
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          &.info_max {
            max-width: 920px;
            white-space: pre-wrap;
          }
        }
        &.info_ct {
          width: 75px;
          margin-right: 25px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          span {
            font-size: 14px;
            font-weight: 400;
            color: rgb(102, 102, 102);
            margin-left: 4px;
            display: flex;
            align-items: center;
            .mgr {
              margin-left: 4px;
              font-size: 18px;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }

  .mainContent {
    background: @bgColor;
    padding: 30px 20px;
    max-height: calc(100vh - 264px);
    overflow: hidden;
    overflow-y: auto;

    .mainBox1 {
      margin-bottom: 20px;
    }

    .title {
      margin-bottom: 22px;

      .desc1 {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: #0072f7;
      }

      .desc2 {
        margin-left: 7px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }

    .industryTag {
      margin-bottom: 15px;

      span {
        display: inline-block;
        width: 62px;
        height: 24px;
        background: rgba(0, 114, 241, 0.07);
        border-radius: 1px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #0072f7;
        line-height: 24px;
        margin: 0 20px 25px 0;

        &:nth-child(1) {
          margin-left: 7px;
        }
      }
    }

    .declareCondition {
      ::v-deep p {
        font-size: 14px !important;
        color: #666 !important;
        font-weight: 400 !important;
        font-family: PingFangSC-Regular, PingFang SC !important;
      }
    }
  }

  .alert-box {
    z-index: 11;
    position: absolute;
    width: 100%;
    top: 22px;

    .alert {
      display: flex;
      justify-content: center;
    }
  }
}
</style>